<app-menu-common url="sales"></app-menu-common>

<div class="rp-page">

  <div class="toolbar-card">

    <div class="toolbar-title">
      <mat-icon class="toolbar-icon">bed</mat-icon>
      <span>Articles de location</span>
    </div>

    <div class="filter-item">
      <label class="filter-label">Id produit</label>
      <smart-input width="96px" type="number" placeholder="N°" [(ngModel)]="filter.product" (valueChange)="apply()" (enterPressed)="apply()" />
    </div>

    <div class="filter-item">
      <label class="filter-label" title="Nom ou référence de l'article, ou nom d'un de ses contrats de location, en entier ou en partie">Article ou contrat</label>
      <smart-input width="260px" placeholder="Rechercher par nom" icon="close" iconClass="custom-icon-button error" [(ngModel)]="filter.text"
        (valueChange)="apply()" (enterPressed)="apply()" (iconClicked)="filter.text = ''; apply()" />
    </div>

    <div class="filter-item">
      <label class="filter-label" title="Code LPP d'un palier du contrat, par son début">Code LPP</label>
      <smart-input width="110px" placeholder="LPP" [(ngModel)]="filter.lpp" (valueChange)="apply()" (enterPressed)="apply()" />
    </div>

    <div class="filter-item">
      <label class="filter-label" for="rp-period">Période</label>
      <select id="rp-period" class="custom-select" [(ngModel)]="filter.period" (ngModelChange)="apply()">
        <option [ngValue]="0">Toutes</option>
        @for (p of periods; track p.id) { <option [ngValue]="p.id">{{ p.name }}</option> }
      </select>
    </div>

    <div class="filter-item">
      <label class="filter-label" for="rp-source">Prix</label>
      <select id="rp-source" class="custom-select" [(ngModel)]="filter.source" (ngModelChange)="apply()">
        <option value="">Tous</option>
        @for (s of sources; track s.id) { <option [value]="s.id">{{ s.name }}</option> }
      </select>
    </div>

    <div class="filter-item">
      <label class="filter-label">Conforme FSE</label>
      <button type="button" class="flag-filter" [class.state-yes]="filter.secu === true" [class.state-no]="filter.secu === false"
        [matTooltip]="TRI_HINT + '\nOui : contrats qui passent les contrôles Sécu du passage ; Non : ceux qu\'ils refuseraient.'" matTooltipClass="tooltip-multiline" (click)="cycle('secu')">
        <mat-icon>{{ triIcon(filter.secu) }}</mat-icon><span>{{ triText(filter.secu) }}</span>
      </button>
    </div>

    <div class="filter-item">
      <label class="filter-label">Actif</label>
      <button type="button" class="flag-filter" [class.state-yes]="filter.active === true" [class.state-no]="filter.active === false"
        [matTooltip]="TRI_HINT + '\nUn contrat inactif n\'est plus proposé à la saisie F3.'" matTooltipClass="tooltip-multiline" (click)="cycle('active')">
        <mat-icon>{{ triIcon(filter.active) }}</mat-icon><span>{{ triText(filter.active) }}</span>
      </button>
    </div>

    <div class="filter-item">
      <label class="filter-label">Règles posées</label>
      <button type="button" class="flag-filter" [class.state-yes]="filter.rules === true" [class.state-no]="filter.rules === false"
        [matTooltip]="TRI_HINT + '\nOui : le contrat porte ses règles de facturation ; Non : le moteur lui applique ses défauts.'" matTooltipClass="tooltip-multiline" (click)="cycle('rules')">
        <mat-icon>{{ triIcon(filter.rules) }}</mat-icon><span>{{ triText(filter.rules) }}</span>
      </button>
    </div>

    <div class="filter-item add-item">
      <label class="filter-label" title="Choisir un produit pour en faire un article de location : sa fiche s'ouvre, prête pour son premier contrat de location">Nouvel article de location</label>
      <app-search-product width="250px" placeholder="Produit à louer" (selectProductEmitter)="onProductPicked($event)"></app-search-product>
    </div>

    <div class="toolbar-actions">
      <button type="button" class="btn-inline btn-search" (click)="load()" matTooltip="Relire le catalogue des articles de location">
        <mat-icon [class.spinning]="loading">refresh</mat-icon><span>Rechercher</span>
      </button>
      <button type="button" class="btn-inline btn-clear" aria-label="Effacer" title="Vider les filtres" (click)="clear()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>

  <div class="table-card">
    <div class="table-header-bar">
      <div class="table-title">
        <mat-icon>list_alt</mat-icon>
        <span>Articles et leurs contrats de location</span>
        <span class="badge-count" matTooltip="Articles affichés">{{ groups.length }}</span>
        <span class="badge-count muted" matTooltip="Contrats de location affichés (une ligne par contrat)">{{ cardCount }}</span>
      </div>
      <div class="legend">
        <span class="legend-chip secu-ok" matTooltip="Le contrat passe les contrôles Sécu du passage">FSE</span>
        <span class="legend-chip defaults" matTooltip="Aucune règle posée sur le contrat : le moteur applique ses défauts">Défauts</span>
        <span class="legend-chip shared" matTooltip="Nombre d'articles qui portent le contrat : le modifier les change tous">×N partagé</span>
      </div>
    </div>

    @if (loading && !rows.length) {
      <div class="state-box"><mat-spinner diameter="28"></mat-spinner><span>Chargement des articles de location…</span></div>
    } @else if (error) {
      <div class="state-box error"><mat-icon>error_outline</mat-icon><span>{{ error }}</span></div>
    } @else if (!groups.length) {
      <div class="state-box">
        <mat-icon class="empty-icon">search_off</mat-icon>
        <span>{{ rows.length ? 'Aucun article ne répond à ces filtres.' : 'Aucun article ne porte encore de contrat de location.' }}</span>
      </div>
    } @else {
      <div class="rp-table">
        <div class="rp-line entete" role="row">
          <div class="cell c-id sortable" (click)="sortBy('id')" role="columnheader">{{ sortKey === 'id' ? (sortAsc ? '↑' : '↓') : '' }} Id</div>
          <div class="cell sortable" (click)="sortBy('name')" role="columnheader">{{ sortKey === 'name' ? (sortAsc ? '↑' : '↓') : '' }} Article</div>
          <div class="cell" matTooltip="Contrat de location proposé à la saisie F3, dans son rang">Contrat de location</div>
          <div class="cell">Période</div>
          <div class="cell num" matTooltip="Prix de la 1re période aujourd'hui : HT du contrat, ou tarif LPP TTC quand le prix vient de la nomenclature">1re période</div>
          <div class="cell" matTooltip="Code LPP du palier 1 de la grille en vigueur">LPP</div>
          <div class="cell num" matTooltip="Paliers de la grille en vigueur ; l'horloge signale une grille datée">Paliers</div>
          <div class="cell">Prix</div>
          <div class="cell" matTooltip="Interruption · fin · trop-facturé · prescription">Règles</div>
          <div class="cell center">FSE</div>
          <div class="cell num" matTooltip="Articles qui portent ce contrat">Partagé</div>
          <div class="cell center" matTooltip="Contrat proposé à la saisie F3">Act.</div>
        </div>

        @for (g of groups; track g.row.id; let even = $even) {
          <!-- Deux zones de clic : l'article (numéro et nom, sur toute la hauteur du groupe) et chaque contrat de location (sa petite ligne). -->
          <div class="rp-group" [class.even]="even">
            <a class="rp-article unstyled-link" [style.grid-row]="'1 / span ' + g.lines.length" [routerLink]="['/sales/rental-product', g.row.id]"
              matTooltip="Ouvrir l'article" matTooltipPosition="right">
              <div class="cell c-id">{{ g.row.id }}</div>
              <div class="cell c-name">
                <span class="p-name" [title]="g.row.name ?? ''">{{ g.row.name || '—' }}</span>
                @if (g.hidden) { <span class="p-more" [matTooltip]="g.hidden + ' autre(s) contrat(s) écarté(s) par les filtres'">+{{ g.hidden }}</span> }
              </div>
            </a>
            @for (l of g.lines; track l.card.id; let i = $index) {
              <a class="rp-line unstyled-link" [class.inactive]="!l.card.is_active" [style.grid-row]="i + 1"
                [routerLink]="['/sales/rental-product', g.row.id, l.card.id]">
                <div class="cell c-card" [title]="'Ouvrir le contrat : ' + l.card.name">
                  <span class="seq">{{ l.card.seq }}</span>{{ l.card.name }}
                </div>
                <div class="cell">{{ l.periodLabel }}</div>
                <div class="cell num">
                  @if (l.price !== null) { {{ l.price | number: '1.2-2' }}<span class="unit">{{ l.lpp ? 'TTC' : 'HT' }}</span> } @else { <span class="faint">—</span> }
                </div>
                <div class="cell mono">{{ l.lppCode }}</div>
                <div class="cell num">{{ l.tiers }}@if (l.dated) { <mat-icon class="mini" matTooltip="Le contrat porte une grille datée (tarif à venir ou passé)">schedule</mat-icon> }</div>
                <div class="cell">{{ l.sourceLabel }}</div>
                <div class="cell" [matTooltip]="l.rulesHint">
                  @if (l.card.billing_error) {
                    <span class="rules-error"><mat-icon class="mini">error</mat-icon>Règles illisibles</span>
                  } @else {
                    @if (!l.explicit) { <span class="chip defaults">Défauts</span> }
                    <span [class.faint]="!l.explicit">{{ l.rulesLabel }}</span>
                  }
                </div>
                <div class="cell center" [matTooltip]="secuHint(l)" matTooltipClass="tooltip-multiline">
                  @if (!l.secu.length) { <span class="chip secu-ok">FSE</span> } @else { <span class="faint">—</span> }
                </div>
                <div class="cell num">
                  @if ((l.card.products_count ?? 1) > 1) { <span class="chip shared">×{{ l.card.products_count }}</span> }
                </div>
                <div class="cell center">
                  <mat-icon class="flag" [class.on]="l.card.is_active">{{ l.card.is_active ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                </div>
              </a>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
